var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.09 0H6.90999C3.09371 0 0 3.09371 0 6.90999V31.09C0 34.9063 3.09371 38 6.90999 38H31.09C34.9063 38 38 34.9063 38 31.09V6.90999C38 3.09371 34.9063 0 31.09 0Z",
    fill: "#5289F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 6,
    fill: "#5289F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4964 27.7894C14.3518 27.7894 14.2037 27.7526 14.0725 27.6826C13.7898 27.529 13.6115 27.2319 13.6115 26.9115V11.0861C13.6115 10.7657 13.7898 10.4686 14.0725 10.315C14.3585 10.1615 14.7051 10.1715 14.9776 10.3484L27.3835 18.2594C27.6358 18.4197 27.7906 18.7 27.7906 18.9971C27.7906 19.2942 27.6358 19.5746 27.3835 19.7348L14.9776 27.6458C14.8329 27.7393 14.6647 27.786 14.4998 27.786L14.4964 27.7894ZM15.3814 12.6984V25.2992L25.2603 18.9971L15.3814 12.695V12.6984Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.bd4050028b9efbcfc08b493dc56f919f.svg";
export { ForwardRef as ReactComponent };